export const ConvertToFAQTicket = {
  component_type: 'form',
  component_name: 'static_form',
  name: 'query',
  data_validations: [],
  child_form: [],
  instant_update: false,
  repeatable_form: 0,
  grid_tab_method: 'faqs_update',
  grid_tab_parent_required: false,
  grid_tab_parent_key: null,
  grid_tab_parent_table: null,
  grid_tab_repeatable: false,
  grid_tab_table: 'faqs',
  layout: '[{"column":[{"col":"12"}]}]',
  permission: 'no_permission',
  allowed: true,
  cols: 6,
  template_name: false,
  icon_type: 'Pe7',
  icon: 'fa-solid fa-plus-large',
  cms_header_key: false,
  cms_sub_header_key: false,
  component_call_fields: [
    {
      component_type: 'fields',
      component_name: 'select',
      name: 'query_type',
      is_layout: null,
      row_index: null,
      block_index: null,
      col: 12,
      section_rowspan: null,
      field_setting: {
        import: true,
        export: true,
        is_copy_allowed: null,
        depend_fields: null,
        disable_if: [],
        textarea: false,
      },
      cms_value: 'Query type',
      permission: null,
      field_id: 'query_type_id',
      cms_key: 'field.query_type',
      cms_tooltip: null,
      component_call_data_connection: {
        component_type: 'data_connection',
        component_name: 'template_data',
        source_table: 'query_types',
        fields: 'id,name',
        clause_data: [],
      },
      selected_value: null,
      disabled: false,
      hidden: false,
      search: false,
      hide_from_grid: false,
      background_color: false,
      component_call_validation: null,
      component_call_actions: null,
      component_call_fields: null,
      format: {
        size: 12,
        searchable: false,
        is_multi_select: false,
      },
      place_holder: null,
      cms_sub_heading: '',
    },
    {
      component_type: 'fields',
      component_name: 'select',
      name: 'query',
      is_layout: null,
      row_index: null,
      block_index: null,
      col: 12,
      section_rowspan: null,
      field_setting: {
        import: true,
        export: true,
        is_copy_allowed: null,
        depend_fields: null,
        disable_if: [],
        textarea: false,
      },
      cms_value: 'Query',
      permission: null,
      field_id: 'query_id',
      cms_key: 'field.query',
      cms_tooltip: null,
      component_call_data_connection: {
        component_type: 'data_connection',
        component_name: 'template_data',
        source_table: 'queries',
        fields: 'id,name',
        clause_data: [],
      },
      selected_value: null,
      disabled: false,
      hidden: false,
      search: false,
      hide_from_grid: false,
      background_color: false,
      component_call_validation: null,
      component_call_actions: null,
      component_call_fields: null,
      format: {
        size: 12,
        searchable: false,
        is_multi_select: false,
      },
      place_holder: null,
      cms_sub_heading: '',
    },
    {
      component_type: 'fields',
      component_name: 'input',
      name: 'question',
      is_layout: 1,
      row_index: 1,
      block_index: 1,
      col: 12,
      section_rowspan: null,
      field_setting: {
        import: true,
        export: true,
        is_copy_allowed: null,
        depend_fields: null,
        disable_if: [],
        textarea: false,
      },
      type: 'input',
      cms_value: 'Question',
      permission: null,
      field_id: 'question',
      cms_key: 'field.question',
      cms_key_tooltip: null,
      cms_key_place_holder: null,
      cms_tooltip: null,
      selected_value: null,
      disabled: false,
      hidden: false,
      hide_from_grid: false,
      background_color: false,
      component_call_validation: [
        {
          component_type: 'validation',
          component_name: 'inline_validation',
          validation_type: 'required',
          message: 'Please complete',
        },
      ],
      component_call_actions: null,
      component_call_fields: null,
      format: {
        size: 12,
      },
      icon_type: null,
      icon: null,
    },
    {
      component_type: 'fields',
      component_name: 'rich_text',
      name: 'answer',
      col: 12,
      is_layout: 1,
      row_index: 1,
      block_index: 1,
      field_id: 'answer',
      section_rowspan: null,
      field_setting: {
        import: true,
        export: true,
        is_copy_allowed: null,
        depend_fields: null,
        disable_if: [],
        textarea: false,
      },
      cms_value: 'Answer',
      permission: null,
      cms_key: 'field.answer',
      cms_key_tooltip: null,
      cms_key_place_holder: null,
      cms_tooltip: null,
      selected_value: null,
      disabled: false,
      hidden: false,
      hide_from_grid: false,
      background_color: false,
      component_call_validation: [
        {
          component_type: 'validation',
          component_name: 'inline_validation',
          validation_type: 'required',
          message: 'Please complete',
        },
      ],
      component_call_actions: null,
      component_call_fields: null,
      format: {
        height: '100px',
        background: '',
      },
      options: {
        'underline ': false,
        bullets: false,
        numbers: false,
        bold: false,
      },
    },
    {
      component_type: 'fields',
      cms_value: 'Display',
      col: 12,
      is_layout: 1,
      row_index: 1,
      block_index: 1,
      section_rowspan: null,
      field_setting: {
        import: true,
        export: true,
        is_copy_allowed: null,
        depend_fields: null,
        disable_if: [],
        textarea: false,
      },
      permission: null,
      component_name: 'toggle_switch',
      field_id: 'display',
      cms_key: 'field.display',
      cms_key_tooltip: null,
      hide_from_grid: false,
      component_call_data_connection: null,
      selected_value: null,
      disabled: false,
      hidden: false,
      background_color: false,
      component_call_validation: null,
      component_call_actions: null,
      format: null,
    },
  ],
  component_call_data_connection: null,
  uuid: '39b8bb9e-7161-4764-af12-456cc80cebe9',
  multiple_data: 0,
}
